(() => {
  angular
    .module('gm.common.directives')
    .directive('gmFlyout', gmFlyoutDirective);

  function gmFlyoutDirective(
    $timeout,
    $document
  ) {
    'ngInject';

    return {
      restrict: 'A',

      link(scope, element, attrs) {
        let isProcessClick = true;

        function hideCb() {
          if (isProcessClick) {
            setContainerShowing(false);
            element.trigger('gm:flyout-close');
          }
        }

        function isContainerShowed() {
          return !!attrs.gmFlyout;
        }

        function onClickInside() {
          isProcessClick = false;
          $timeout(() => {
            isProcessClick = true;
          }, 10);
        }

        function setContainerShowing(isShow) {
          $timeout(() => attrs.$set('gmFlyout', isShow));
        }

        element.on('click', onClickInside);
        $document.on('click', hideCb);

        element.on('gm:flyout-open', () => setContainerShowing(true));
        scope.$on('gm:flyout-open', () => setContainerShowing(true));

        element.on('gm:flyout-switch', () => setContainerShowing(!isContainerShowed()));
        scope.$on('gm:flyout-switch', () => setContainerShowing(!isContainerShowed()));

        element.on('gm:flyout-close', () => setContainerShowing(false));
        scope.$on('gm:flyout-close', () => setContainerShowing(false));

        attrs.$observe('gmFlyout', (isShowContainerNewValue) => {
          const containerEl = element.find('.flyout');
          if (isShowContainerNewValue) {
            containerEl.addClass('flyout--active');
            containerEl.find('[autofocus]').focus();
            scope.$emit('gm:flyout-opened');
          } else {
            containerEl.removeClass('flyout--active');
            scope.$emit('gm:flyout-closed');
          }
          scope.flyoutOpen = isShowContainerNewValue;
        });

        scope.gmFlyoutClose = () => {
          setContainerShowing(false);// works only for isolated scopes
        };

        scope.$on('$destroy', () => $document.off('click', hideCb));
      },
    };
  }
})();
